import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { getStatusBadge } from './helpers';

const StatusCard = ({
  account, teamUsers, completionState, isOwnTeam,
  canEditAccounts, hasEditAccess, canReassign,
  onStatusChange, onAssigneeChange, onComplete
}) => {
  return (
    <div className="bg-surface border border-border rounded-lg p-4" data-testid="account-status-card">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-heading font-semibold text-text-primary">Status</h2>
        <span className="text-sm text-text-secondary">{account.current_team}</span>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm text-text-secondary mb-1">Current Status</label>
          {canEditAccounts && hasEditAccess && account.status !== 'Blocked' && account.status !== 'Completed' ? (
            <select
              value={account.status}
              onChange={(e) => onStatusChange(e.target.value)}
              className="w-full px-3 py-2 bg-background border border-border rounded-md text-text-primary focus:outline-none focus:ring-2 focus:ring-primary"
              data-testid="status-select"
            >
              <option value="In Progress">In Progress</option>
              <option value="Pending Review">Pending Review</option>
              <option value="On Hold">On Hold</option>
            </select>
          ) : (
            <span className={`inline-flex items-center px-3 py-2 rounded-md text-sm font-medium border ${getStatusBadge(account.status)}`}>
              {account.status}
            </span>
          )}
        </div>
        <div>
          <label className="block text-sm text-text-secondary mb-1">Assigned To</label>
          {canReassign && isOwnTeam ? (
            <select
              value={account.assigned_to || ''}
              onChange={(e) => onAssigneeChange(e.target.value)}
              className="w-full px-3 py-2 bg-background border border-border rounded-md text-text-primary focus:outline-none focus:ring-2 focus:ring-primary"
              data-testid="assignee-select"
            >
              <option value="">Unassigned</option>
              {teamUsers.map(u => (
                <option key={u.id} value={u.id}>{u.name}</option>
              ))}
            </select>
          ) : (
            <span className="text-text-primary">{account.assigned_to_name || 'Unassigned'}</span>
          )}
        </div>
      </div>

      {isOwnTeam && account.status !== 'Completed' && (
        <div className="mt-4 pt-4 border-t border-border">
          <button
            onClick={onComplete}
            disabled={completionState.disabled}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-success text-white rounded-md font-medium hover:bg-success/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            title={completionState.reason || ''}
            data-testid="complete-btn"
          >
            <CheckCircle2 size={18} /> Complete & Close Account
          </button>
          {completionState.reason && (
            <p className="text-xs text-warning mt-2 text-center">{completionState.reason}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default StatusCard;
